import heart_line from '../../../favicon/heart_line.svg'
import invite from '../../../favicon/invite.svg'
import favorite_fill from '../../../favicon/favorite_fill.svg'
import cardImg from '../../../Image/cardImg.png'
import cardlog from '../../../Image/card_log.png'
import currencyFormatter from '../../../Helpers/currencyFormatter'
import Countdown from 'react-countdown'
import EmptyItem from '../../comman/EmptyItem'
import { motion } from "framer-motion";


const List = ({ ...props }) => {
    const { data, onSelectCampaign, markFavorite, setShowInviteModal } = props;

   

    const divAnimate2 = {
        offscreen: { y: 100, opacity: 0 },
        onscreen: {
            y:0,
            opacity: 1,
            transition: {
                type: "spring",
                bounce: 0,
                duration: 1
            }
        }

    };



    const Completionist = () => <span className='text-red-700  font-museob'>Campaign duration ended !</span>;
    const renderer = ({ days, hours, minutes, seconds, completed }) => {
        if (completed) {
            // Render a completed state
            return <Completionist />;
        } else {
            // Render a countdown
            return <div className='flex border px-2 border-black rounded-lg text-white bg-black'>
                <span className='mr-1'><strong className='font-museobb'>{days}</strong> d  <span className='animate-pulse'>:  </span> </span>
                <span className='mr-1'><strong>{hours}</strong> h  <span className='animate-pulse'>: </span> </span>

                <span className='mr-1'><strong>{minutes}</strong> m  <span className='animate-pulse'>:  </span> </span>
                <span className='mr-1'><strong>{seconds}</strong> s </span>

            </div>;
        }
    };

    return (
        <>
            <div
                className='containerAnim mt-5 ms:container ms:mx-auto px-4 ms:px-2 flex flex-col  h-full '>
                <>{data?.length > 0 ? (
                    data?.map((item, i) => (

                        <motion.div key={item?.id} variants={divAnimate2} transition={{ staggerChildren: 0.5 }} initial={"offscreen"} whileInView={"onscreen"} viewport={{ once: true, amount: 0.5 }} className="itemAnim mb-5 px-4 md:px-0 
                         grid md:grid-cols-4  md:grid-rows-1 rounded-lg container mx-auto]
                         " style={{ "boxShadow": "rgb(210 206 206 / 82%) 3px 5px 20px 1px" }}>
                            <div 
                                onClick={() => { onSelectCampaign(item) }} className="cursor-pointer flex justify-center md:justify-start  ">
                                <img className="p-1 ssm:w-[329.787px] ssm:h-[188px] object-cover object-top rounded-xl" src={item?.campaignLogo ? item?.campaignLogo : cardImg} alt="img not found" />
                            </div>
                            <div className="md:col-start-2 md:col-end-5 md:grid md:grid-cols-1 md:grid-rows-8" >
                                <div className="md:row-start-1 md:row-end-7">
                                    <div className=" py-2 md:grid md:grid-cols-3 md:grid-row-1 h-full  border-b-2" >
                                        <div onClick={() => { onSelectCampaign(item) }} className=" cursor-pointer col-start-1 col-end-3 md:pl-7 pl-2  max-w-[625px] grid place-items-stretch ">
                                            <h5 className="text-[#178ACB] text-lg font-museobb  ">{item?.campaign_title}</h5>
                                            <div>
                                                <p className="text-gray-600 font-museo ">{item?.description}</p>
                                                <span className="text-gray-600 font-museob  ">Live Date: {item?.live_date} </span><br></br>
                                                <span className="text-gray-600 font-museob  ">Duration: {item?.duration_start_date} ~ {item?.duration_end_date}</span>
                                            </div>
                                            <div className="flex gap-2 flex-wrap md:mt-0 mt-2 items-end">
                                                {item?.allocatedBudget?.map((range, index) => (
                                                    <span key={index + item.id} className="bg-[#66BE9C] px-2 py-1 text-white text-xs font-museo text-center rounded-full ">{range?.soical_paltfom}</span>
                                                ))}
                                            </div>

                                        </div>
                                        <div className=" md:justify-end md:content-between  md:grid items-center md:justify-items-end
                                            flex justify-between mt-2 md:mt-0 md:pr-5  md:px-0  ">
                                            <img src={item.brand_logo ? item.brand_logo : cardlog} alt="brand_logo" className="max-w-16 object-cover object-center max-h-16" />


                                            <div className='cursor-pointer flex gap-x-2  ' >
                                                <div className='cursor-pointer  ' onClick={() => setShowInviteModal(item?.id)} >
                                                    <img alt="Invite" src={invite} />
                                                </div>

                                                {item?.is_favorite
                                                    ?
                                                    (<img alt='fav' className='w-7 h-7 heart' onClick={(e) => { e.preventDefault(); markFavorite(item?.id) }} src={favorite_fill} />)
                                                    :
                                                    (<img alt='fav_filled' className='w-7 h-7  ' onClick={(e) => { e.preventDefault(); markFavorite(item?.id); }} src={heart_line} />)}

                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="flex  md:flex-row flex-col md:items-center justify-between gap-y-2 sm:gap-y-0 py-2 md:px-4 px-2">

                                    <div className='flex ssm:flex-row flex-col justify-between md:w-[50%] md:mb-0 mb-2'>
                                        <p className='sm:text-md font-museob text-slate-600  text-sm'>{item?.category_id}</p>
                                        <div className='flex sm:gap-x-5 items-center justify-between'>
                                            <Countdown
                                                date={new Date(item?.duration_end_date).getTime()}
                                                renderer={renderer}
                                            />

                                        </div>
                                    </div>

                                    <div className='flex sm:gap-x-5 items-center justify-between  '>
                                        <span className="sm:text-md text-sm font-museob text-slate-600" >Cash Pool</span>
                                        <span className='sm:text-2xl text-xl  font-museobb  text-green-600' >RM  {currencyFormatter.format(item?.budget)}</span>
                                    </div>

                                </div>
                            </div>
                        </motion.div >
                    ))
                ) : (
                    <EmptyItem text={'No campagin Found'} />
                )}</>


            </div>
        </>

    )
}

export default List;